import { render, staticRenderFns } from "./ViewRoute.vue?vue&type=template&id=61a2d73e&scoped=true&"
import script from "./ViewRoute.vue?vue&type=script&lang=js&"
export * from "./ViewRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a2d73e",
  null
  
)

export default component.exports